var navApp = angular.module('navApp', ['sharedServices','configService','sharedFilters','searchData','ngCookies','vendorCategoryServices']);

navApp.config(function($interpolateProvider,$httpProvider) {
    $interpolateProvider.startSymbol('{[');
    $interpolateProvider.endSymbol(']}');
    $httpProvider.interceptors.push('APIInterceptor');
});
navApp.directive('subNav', function() {
    return {
        restrict: 'A',
        templateUrl: '/html/navApp.html',
    }
})

navApp.directive('subSearch', function() {
    return {
        restrict: 'A',
        templateUrl: '/html/searchview.html',
    }
})

navApp.directive('lowercasefilter', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, modelCtrl) {
            var lowercase = function (inputValue) {
                if (inputValue == undefined) inputValue = '';
                var lowercased = inputValue.toLowerCase();
                if (lowercased !== inputValue) {
                    // see where the cursor is before the update so that we can set it back
                    var selection = element[0].selectionStart;
                    modelCtrl.$setViewValue(lowercased);
                    modelCtrl.$render();
                    // set back the cursor after rendering
                    element[0].selectionStart = selection;
                    element[0].selectionEnd = selection;
                }
                return lowercased;
            }
            modelCtrl.$parsers.push(lowercase);
            lowercase(scope[attrs.ngModel]); // capitalize initial value
        }
    };
});

navApp.controller('navController', ['$scope', '$http', '$rootScope', '$location', '$window', '$timeout', 'logoutUser', 'getUserInfo', 'config', 'EncryptedLocalStorage', 'joinW', 'getSearchInfo', 'getSearchSuggest', 'getPopularSearches', 'vendorDashboard','$cookies','vendorCategoryName',
    function ($scope, $http, $rootScope, $location, $window, $timeout, logoutUser, getUserInfo, config, EncryptedLocalStorage, joinW, getSearchInfo, getSearchSuggest, getPopularSearches, vendorDashboard, $cookies, vendorCategoryName) {
    $scope.navProfile = {};
    $scope.searchValue = {};
    $scope.S3_URL = config.S3_URL;
    var locationFlag = 0; // flag to emit customEvent only when navigating through navbar
    $scope.logged_in = false;
    $scope.isMobile = false;
    $scope.settingsUrl = config.domain + '/dashboard/profile/settings';
    $scope.inboxUrl = config.domain + '/dashboard/inbox';
    $scope.bookingUrl = config.domain + '/dashboard/user/booking/';
    $scope.createWUrl = config.domain + '/dashboard/profile/createwedding';
    $scope.profileFeedUrl = config.domain + '/dashboard/profile/feeds/';
    $scope.vendorFeedUrl = config.domain + '/vendor/feeds/leads?id='+evalVendorLink(localStorage.redux);
    $scope.globalSearchQuery = '';
    $scope.typedString = '';
    $scope.currentSelection = -1;
    $scope.vendorSettingUrl = config.domain + '/vendor/settings/';
    $scope.navProfile.profile_pic = '';
    $scope.vendorCategoryData = {};
    var bgJoin = 0;
    // bad code to find if current localStorage token is encrypted, if yes, decrpyt and update in LS
    if (localStorage.getItem('token') && localStorage.getItem('token').length !== 23) {
        var decryptedToken = EncryptedLocalStorage.get('token');
        if (decryptedToken) {
            localStorage.setItem('token', decryptedToken);
        }
    }
    if (localStorage.getItem('vtoken') && localStorage.getItem('vtoken').length !== 23) {
        var decryptedVtoken = EncryptedLocalStorage.get('vtoken');
        if (decryptedVtoken) {
            localStorage.setItem('vtoken', decryptedVtoken);
        }
    }
    config.token = localStorage.getItem('token');
    config.vtoken = localStorage.getItem('vtoken');
    //getting fb pic if present
    if (localStorage.getItem('profile_pic')) {
        $scope.navProfile.profile_pic = localStorage.getItem('profile_pic');
    }

    // code to remove 'no image found' icon
    $('.nav-user-pic').error(function() {
        $(this).hide();
    });

    $('.searchBox').keyup(function(e) {
        clearTimeout($.data(this, 'timer'));
        $(this).data('timer', setTimeout(search, 100));
    });

    $scope.isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (localStorage.getItem('logged_in')) {
        $scope.navProfile.logged_in = true;
    } else {
        $scope.navProfile.logged_in = false;;
    }

    // checking if vendor is logged in
    if(localStorage.getItem('vendor_logged_in')) {
        $scope.navProfile.vendor_logged_in = true;
    } else {
        $scope.navProfile.vendor_logged_in = false;
    }

    function callPopularSearches(type) {
        getPopularSearches(type, config.token)
            .then(function (response) {
                $scope.popularSearches = response.data;
            })
            .catch(function (err) {
                console.log(err);
            });
    }

    function evalVendorLink(reduxKey){
      try{
        return JSON.parse(reduxKey).profile.profile.vendor_id;
      }catch(e){
        return '';
      }
    }

    // code to run when WOHOO is closed
    $('#joinedModal').on('hidden.bs.modal', function () {
        $window.location.reload();
    })
    $scope.openJModal = function() {
        $('#joinAwModal').modal('show');
    }
    $('#joinedModal').on('hidden.bs.modal', function () {
        if(bgJoin) {
            localStorage.setItem('wedding_id',config.wedding_id)
            $window.location.href= config.domain + '/dashboard/profile/feeds/';
            bgJoin = 0;
        }
    });

    function escapeKeyListener(e){
      if (e.key === 'Escape'){
        $scope.searchValue.inputvalue = '';
        $scope.searchValue.data = [];
        return;
      }
    }

    $scope.onSearchClick = function(){
      if(!$scope.searchShow){
        $('#srch-term').focus();
        $('#sov').show();
        document.addEventListener('keydown', escapeKeyListener);
        $('#nav-search').addClass('nav-search-60');
        $('#nav-search-bar').addClass('nav-search-bar-show').removeClass('nav-search-bar');
        $('#nav-menu-header').addClass('nav-menu-header-hide').removeClass('nav-menu-header');
        $scope.searchShow = true;
      }else{
        $('#sov').hide();
        document.removeEventListener('keydown', escapeKeyListener);
        $('#nav-search').removeClass('nav-search-60');
        $('#nav-search-bar').addClass('nav-search-bar').removeClass('nav-search-bar-show');
        $('#nav-menu-header').addClass('nav-menu-header').removeClass('nav-menu-header-hide');
        $scope.searchShow = false;
      }
    }

    $scope.overlayClick = function(){
      $('#sov').hide();
      document.removeEventListener('keydown', escapeKeyListener);
      $('#nav-search').removeClass('nav-search-60');
      $('#nav-search-bar').addClass('nav-search-bar').removeClass('nav-search-bar-show');
      $('#nav-menu-header').addClass('nav-menu-header').removeClass('nav-menu-header-hide');
      $scope.searchShow = false;
    }

    vendorCategoryName(config.token).success(function(vendorCategoryDetail) {
        $scope.vendorCategoryData.category = vendorCategoryDetail.data.category;
        var len =  $scope.vendorCategoryData.category.length;
        var mid = len/2+1;
        $scope.firstCat = $scope.vendorCategoryData.category.slice(0,mid);
        $scope.secCat = $scope.vendorCategoryData.category.slice(mid);
          $('header').trigger('mastersData',[vendorCategoryDetail]);
    })


    /*
    $timeout(function() {
      vendorCategoryName(config.token).success(function(vendorCategoryDetail) {
        $scope.vendorCategoryData.category = vendorCategoryDetail.data.category;
        var len =  $scope.vendorCategoryData.category.length;
        var mid = len/2+1;
        $scope.firstCat = $scope.vendorCategoryData.category.slice(0,mid);
        $scope.secCat = $scope.vendorCategoryData.category.slice(mid);
        $timeout(function() {
          $('header').trigger('mastersData',[vendorCategoryDetail]);
        },1000);
      })
    },1000);
    */
    $('#nav-mobile-icon').on('click', function (e) {
      if ($('#nav-mobile').hasClass('in')) {
        $('.bodycontainer').removeClass('sidebar-opacity');
      } else {
        window.setTimeout(function() {
          $('.bodycontainer').addClass('sidebar-opacity');
        },250)
      }
    });
    $timeout(function() {
      if (!/iPad/i.test(navigator.userAgent)) {
        $('#nav-dApp').removeClass('hide');
      }
    },1000)

    if (window.location.pathname != '/vendors/' && !/iPad|iPod/i.test(navigator.userAgent)) {
      $('#v-nav-cat').mouseenter(function (e) {
        var $that = $(e.target);
        $that.closest('div').find('.v-cat-view').toggleClass('invisible');
        $('.v-cat-li').mouseenter(function(event) {
          var $that = $(event.target);
          $that.closest('li').find('.black-cat').addClass('gayab');
          $that.closest('li').find('.pink-cat').removeClass('gayab');
          $that.closest('li').find('span').css('color','#e72e77');
        })

        $('.v-cat-li').mouseleave(function(event) {
          var $that = $(event.target);
          $that.closest('li').find('.black-cat').removeClass('gayab');
          $that.closest('li').find('.pink-cat').addClass('gayab');
          $that.closest('li').find('span').css('color','#4a4a4a');
        })
        event.stopPropagation();
      })
      $('#v-nav-cat').mouseleave(function (e) {
        var $that = $(e.target);
        $('.v-cat-view').addClass('invisible');
      });
    }


    $scope.goToHomepage = function() {
      window.location.href = '/';
    }

    $scope.submitWedCode = function(code) {
        $('#joinAwModal').find('.join-error').css('display', 'none');
        $('#joinAwModal').find('.invite-error').css('display', 'none');
        $('#joinAwModal').find('.required-error').css('display', 'none');
        if($('#joinAwModal').find('input').val() == '') {
            $('#joinAwModal').find('.required-error').css('display', 'block');
            return false;
        }
        $('#joinAwModal').find('.inviteWbutton').text('');
        $('#joinAwModal').find('.invite-spin').css('display', 'block');
        joinW(config.token, code).then(function(data) {
            if (data.data.response.status) {
                $('#joinAwModal').find('.invite-spin').css('display', 'none');
                $('#joinAwModal').find('.invite-done').css('display', 'block');
                $('#joinAwModal').modal('hide');
                $('#joinedModal').modal('show');
                $scope.navProfile.joinedWWeddingTitle = data.data.data.wedding_title;
                if(data.data.data.role == 'Bride' || data.data.data.role == 'Groom') {
                    bgJoin = 1;
                    config.wedding_id = data.data.data.wedding_id;

                }
            } else {
                $('#joinAwModal').find('.invite-error').css('display', 'block');
                $('#joinAwModal').find('.join-error').css('display', 'block');
                $('#joinAwModal').find('.join-error').text('*' + data.data.response.message);
                $('#joinAwModal').find('.invite-spin').css('display', 'none');
                $('#joinAwModal').find('.inviteWbutton').text('JOIN');
            }
        }, function() {})
    }
    // vendor log out
    $scope.logoutVendor = function() {
        logoutUser(config.vtoken).success(function() {
            localStorage.removeItem("vendor_logged_in");
            localStorage.removeItem("redux");
            window.location.href = config.domain;
            window.localStorage.SYNCED_ACTIONS = JSON.stringify({
                type: 'LOGOUT_SUCCESS'
            });
        });
    }

    $scope.logOut = function() {
        logoutUser(config.token).success(function() {
            localStorage.removeItem("logged_in");
            localStorage.removeItem('wedding_id');
            localStorage.removeItem('wedding_code');
            localStorage.removeItem('wedding_date');
            localStorage.removeItem('profile_pic');
            localStorage.removeItem('mobileNumber');
			localStorage.removeItem('email');
			localStorage.removeItem('name');
			localStorage.removeItem('redux');
            window.location.href = config.domain;
            window.localStorage.SYNCED_ACTIONS = JSON.stringify({
                type: 'LOGOUT_SUCCESS'
            });
        });
    }

    window.addEventListener('storage', function(evt) {
        if (evt.key !== 'SYNCED_ACTIONS') {
            return;
        }
        if (JSON.parse(evt.newValue).type === 'LOGOUT_SUCCESS') {
            $scope.logOut();
            $scope.logoutVendor();
        }
    });

    $scope.popularSearch = {};
    $scope.defaultType = '';
    $scope.searchString = '';
    $scope.searchData = {};

    $scope.newURL = function(){
     if (localStorage.getItem("vendorCity") != null) {
            var city = localStorage['vendorCity'];
            $scope.userCity = city;
        }else{
            $scope.userCity = "";
        }
    }

    $scope.newGalleryUrl = function(){
        $scope.galleryCity = "";
        if (localStorage.getItem("galleryCity") != null) {
            var city = localStorage['galleryCity'];
            if(city!="all"){
                $scope.galleryCity ="/"+city;
            }
        }
    }

    $scope.showSearch = function() {
            $timeout(function() {
                $('#search-box').find('input').focus();
            },1000);
            $('#modal-search').modal('show');
            $('.button-collapse').hide();
            if(!$scope.searchString) {
                getSearchInfo($scope.searchString,config.token).then(function(success) {
                    $scope.popularSearch = success.data.popular_search;
                    $scope.defaultType = success.data.default_type;
                })
            }
        }

    $scope.closeSearch = function() {
        $('#modal-search').modal('hide');
    }

    $scope.openLoginModal = function () {
        window.location.href = '/login?referrer=/';
    }

    $scope.searchSuggestQuery = function (e) {
        if(e.key === 'Backspace') {
            $scope.currentSelection = -1;
        }
        if (e.key === 'Enter' && e.target.value !== '') { // enter
            $scope.searchRedirect(e.target.value, $scope.searchTypeSelection, $scope.obj);
        }
        if (e.key === 'ArrowRight' && e.target.value !== '' && e.target.value.length === e.target.selectionEnd) { // right arrow key
            $scope.globalSearchQuery = $scope.searchData[0].text.toLowerCase();
            $scope.obj = $scope.searchData[0];
            searchSuggest();
        }
        if (e.key === 'ArrowDown' && e.target.value !== '' && $scope.searchData.length !== 0 && $scope.currentSelection < $scope.searchData.length - 1) {
            var x = $scope.currentSelection + 1;
            $scope.currentSelection = x;
            $scope.globalSearchQuery = $scope.searchData[x].text;
            $scope.searchTypeSelection = $scope.searchData[x].type;
            $scope.obj = $scope.searchData[x];
        }
        else if (e.key === 'ArrowUp' && e.target.value !== '' && $scope.searchData.length !== 0 && $scope.currentSelection >= 0) {
            var x = $scope.currentSelection - 1;
            if (x !== -1) {
                $scope.currentSelection = x;
                $scope.globalSearchQuery = $scope.searchData[x].text.toLowerCase();
                $scope.searchTypeSelection = $scope.searchData[x].type;
                $scope.obj = $scope.searchData[x];
            }
            else {
                $scope.currentSelection = -1;
                $scope.globalSearchQuery = $scope.typedString.toLowerCase();
                $scope.searchTypeSelection = 1;
                $scope.obj = $scope.searchData[0];
            }
        }
        else {
            $scope.typedString = $scope.globalSearchQuery;
        }

        clearTimeout($.data(this, 'timer'));
        if($scope.currentSelection === -1) {
            $(this).data('timer', setTimeout(searchSuggest, 500));
        }
    };

    function searchSuggest(e) {
        if ($scope.globalSearchQuery !== '') {
            getSearchSuggest($scope.globalSearchQuery, $scope.searchType.type, config.token).then(function (success) {
                if ($scope.globalSearchQuery.length && (success.status !== 204 && success.data.data && success.data.data.length)) {
                    $('.no-result').addClass('hide');
                    $scope.searchData = success.data.data;
                    $('.sub-search').css('display', 'block');
                    $('.suggested-search').addClass('hide');
                } else if ($scope.globalSearchQuery.length) {
                    $('.suggested-search').addClass('hide');
                    $scope.searchData = [];
                    $('.no-result').removeClass('hide');
                    $('.sub-search').css('display', 'none');
                } else {
                    $scope.searchData = [];
                    $('.no-result').addClass('hide');
                    $('.sub-search').css('display', 'none');
                    $('.suggested-search').removeClass('hide');
                }
            }, function (err) {
                $('.sub-search').css('display', 'none');
                // Materialize.toast('Something Went Wrong!', 5000);
            });
        }
        else {
            $scope.searchData = [];
        }
    }

    $scope.searchQuery = function() {
        clearTimeout($.data(this, 'timer'));
        $(this).data('timer', setTimeout(searchMobile, 500));
    };

    function searchMobile(e) {
        //console.log('e',e)
        getSearchInfo($scope.searchString,config.token).then(function(success) {
            if($scope.searchString.length && (success.data.data[0].suggestion.length || success.data.data[1].suggestion.length || success.data.data[2].suggestion.length)) {
                $('.no-result').addClass('hide');
                $scope.searchData = success.data.data;
                $scope.searchOne = success.data.data[0];
                $scope.searchTwo = success.data.data[1];
                $scope.searchThree = success.data.data[2];
                $('.sub-search').css('display','block');
                $('.suggested-search').addClass('hide');
                //console.log("aaya",$scope.searchValue);
            } else if($scope.searchString.length) {
                $('.suggested-search').addClass('hide');
                $('.no-result').removeClass('hide');
                $('.sub-search').css('display','none');
            } else {
                $('.no-result').addClass('hide');
                $('.sub-search').css('display','none');
                $('.suggested-search').removeClass('hide');
            }
           /* if(e.keyCode == 13) {
               window.location.href =  config.domain + '/search/'+ $scope.searchString+'#/' +success.data.default_type;
            }*/
        },
        function(err){
            $('.sub-search').css('display','none');
            Materialize.toast('Something Went Wrong!', 5000);
        });
    }

    $scope.closeFooter = function() {
            $('#app-fixed-footer-m').css('display','none !important');
            var date = new Date();
            var minutes = 7;
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            $cookies.put("downloadpopup", "true", { expires: date });
            $('#header').removeClass('adf')
            $('#AppIcon').css('margin-top','16%');
        };

    $scope.goToUserLocation = function(loc,type) {
        if (type == 'blog') {
            window.location.href = 'https://www.wedmegood.com/blog/' + loc
        } else {
            window.location.href = config.domain + loc
        }
    };

     if(/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            if(!$cookies.get('downloadpopup')) {
                $('#header').addClass('adf');
                $('#app-fixed-footer-m').css({"display":"block","z-index":"3"});
            } else {
                $('#header').removeClass('adf');
            }
            if(/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                $('.iphone-show').removeClass('hide')
            } else {
                $('.android-show').removeClass('hide')
            }
        };

        if (config.vtoken && $scope.navProfile.vendor_logged_in) {
            $('#settingApp').on('updateVendorPic', function(event, data) {
                 $scope.$apply(function() {
                    console.log(data,"text");
                    $scope.navProfile.vendorInfo.vendor_profile_pic_url = data;
                    $scope.navProfile.vendorInfo.vendor_original_pic_url = data;
                })
            });
        }
    if (config.token && $scope.navProfile.logged_in) {
        getUserInfo(config.token).success(function(data) {
            $scope.navProfile.userInfo = data.data;
            $timeout(function() {
              $('#navApp').trigger('sendUserData', [$scope.navProfile.userInfo[0]]);
            },1000)
            if ($scope.navProfile.userInfo && (($scope.navProfile.userInfo[0].profile_pic_url.indexOf('profile_placeholder') == -1 ) || (($scope.navProfile.userInfo[0].profile_pic_url.indexOf('profile_placeholder') != -1 ) && !localStorage.getItem('profile_pic')))) {
                if((!$scope.navProfile.userInfo[0].thumb_status || $scope.navProfile.userInfo[0].thumb_status == "0") && $scope.navProfile.userInfo[0].profile_pic_url.indexOf('profile_placeholder') == -1 ) {
                    $scope.navProfile.profile_pic = $scope.navProfile.userInfo[0].original_pic_url;
                } else {
                    $scope.navProfile.profile_pic = $scope.navProfile.userInfo[0].profile_pic_url;
                }
            }
            $scope.createWedding = 'Create Your Wedding';
            if ($scope.navProfile.userInfo && $scope.navProfile.userInfo[0].role) {
                $scope.navProfile.role = $scope.navProfile.userInfo[0].role;
            }
            if ($scope.navProfile.userInfo && $scope.navProfile.userInfo.my_wedding) {
                $('#navApp').trigger('sendWeddingId', [$scope.navProfile.userInfo.my_wedding.wedding_id]);
            } else {
                $('#navApp').trigger('sendWeddingId', ['nowedding']);
            }
            $('#navApp').on('updatePP', function(event, data) {
                $scope.$apply(function() {
                    $scope.navProfile.profile_pic = data;
                })
            })
            if ($scope.navProfile.userInfo) {
                if ($scope.navProfile.userInfo.my_wedding) {
                    config.wedding_id = $scope.navProfile.userInfo.my_wedding.wedding_id;
                } else {
                    config.wedding_id = $scope.navProfile.userInfo.weddings[0].wedding_id;
                }
                if (config.wedding_id.length) {
                    localStorage.setItem('wedding_id', config.wedding_id);
                } else {
                    localStorage.removeItem('wedding_id');
                }
                //config.wedding_id = $scope.navProfile.userInfo.my_wedding.wedding_id;
            }

            // storing wedding_code in localStorage
            if ($scope.navProfile.userInfo && $scope.navProfile.userInfo.weddings) {
                for (var i = 0; i < $scope.navProfile.userInfo.weddings.length; i++) {
                    if ($scope.navProfile.userInfo.weddings[i].wedding_id === config.wedding_id) {
                        config.wedding_code = $scope.navProfile.userInfo.weddings[i].wedding_code;
                        if (config.wedding_code) {
                            localStorage.setItem('wedding_code', config.wedding_code);
                        } else {
                            localStorage.removeItem('wedding_code');
                        }
                    }
                }
            }

            // storing mobile Number in localStorage
            if(!localStorage.getItem('mobileNumber') || localStorage.getItem('mobileNumber') == 'null' || (typeof localStorage.getItem('mobileNumber') == 'undefined')) {
                if($scope.navProfile.userInfo[0].mobileNumber != null && $scope.navProfile.userInfo[0].mobileNumber && (typeof localStorage.getItem('mobileNumber') != 'undefined')) {
                    localStorage.setItem('mobileNumber',$scope.navProfile.userInfo[0].mobileNumber);
                }
            }
            if ($scope.navProfile.userInfo && $scope.navProfile.userInfo.weddings) {
                for (var i = 0; i < $scope.navProfile.userInfo.weddings.length; i++) {
                    if ($scope.navProfile.userInfo.weddings[i].wedding_id === config.wedding_id) {
                        config.wedding_date = $scope.navProfile.userInfo.weddings[i].wedding_date;
                        if (config.wedding_date) {
                            localStorage.setItem('wedding_date', config.wedding_date);
                        } else {
                            localStorage.removeItem('wedding_date');
                        }
                    }
                }
                localStorage.setItem('wedding_id', config.wedding_id);
                //console.log($cookies.get('wedding_id'));
                //config.wedding_id = $scope.navProfile.userInfo.my_wedding.wedding_id;
            }
            // code to detect the wedding title
            if ($scope.navProfile.userInfo && $scope.navProfile.userInfo.weddings) {
                for (var i = 0; i < $scope.navProfile.userInfo.weddings.length; i++) {
                    if ($scope.navProfile.userInfo.weddings[i].wedding_id === config.wedding_id) {
                        //config.wedding_code = $scope.navProfile.userInfo.weddings[i].wedding_code
                        //localStorage.setItem('wedding_code', config.wedding_code);
                        $scope.navProfile.weddingTitle = $scope.navProfile.userInfo.weddings[i].title;
                    }
                }
            }
        });
    }

    // code to get vendor info , of vendor is logged in
    if(config.vtoken && $scope.navProfile.vendor_logged_in) {
        vendorDashboard(config.vtoken).success(function(data) {
            $scope.navProfile.vendorInfo = data.data;
            
            $('#settingApp').trigger('updateSettingPic',[$scope.navProfile.vendorInfo.vendor_original_pic_url]);
            localStorage.setItem('catalog_brand_icon_url', $scope.navProfile.vendorInfo.catalog_brand_icon_url);
            $('#settingApp').trigger('updateVendorLogo',[$scope.navProfile.vendorInfo.catalog_brand_icon_url]);
        });
    }
    // // function used to open the sub-nav , using unbind because multiple handlers were getting attached
    // $('html').unbind().on('click','.user-nav-account',function(event) {
    //     $('.user-nav-account').find('.sub-nav').toggleClass('visible');
    //     // in correlation with sub-nav div hiding.. dont know why it is used exactly
    //     event.stopPropagation();
    // });
    // $('html').on('click','.vendor-nav-account',function(event) {
    //     $('.vendor-nav-account').find('.sub-nav').toggleClass('visible');
    //     event.stopPropagation();
    // });
    $(".open-dropdown").on('click', function (e) {
        $('.user-nav-account').find('.sub-nav').toggleClass('visible');
    });
    // to hide the sub-nav div if clicked outside
    $('html').click(function() {
        $('.sub-nav').removeClass('visible');
    });
    $scope.$on('$locationChangeSuccess', function() {
        config.wedding_id = localStorage.getItem('wedding_id');
        config.wedding_code = localStorage.getItem('wedding_code');
        config.wedding_date = localStorage.getItem('wedding_date');
        if (locationFlag) {
            $("#navApp").trigger('customEvent', [config.wedding_id, config.wedding_code, config.wedding_date]);
            locationFlag = 0;
        }
    });
    $scope.testFunc = function(id, code, date) {
        localStorage.setItem('wedding_id', id);
        if (code) {
            localStorage.setItem('wedding_code', code);
        }
        localStorage.setItem('wedding_date', date);
        config.wedding_id = id;
        locationFlag = 1;
        config.wedding_code = code;
        if (($window.location.pathname === '/dashboard/profile/feeds') && ($window.location.hash === '#/')) {
            $window.location.reload();
        } else {
            $window.location.href = config.domain + '/dashboard/profile/feeds/';
        }
    };

    $('.search-mobile').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        $('.search-input-mobile').css('display','block');
    });

    $scope.goToSearch = function(searchValue,suggest) {
      if (suggest == 'vendor') {
        suggest = 'vendors';
      } else if (suggest == 'image') {
        suggest = 'photos';
      }
      window.location.href = '/search/'+suggest+'/'+searchValue;
    }

    function search(force) {
        //var existingString = $("#searchString").val();
        //console.log("new,",$scope.searchValue.inputvalue);
      getSearchInfo($scope.searchValue.inputvalue,config.token).then(function(success) {
        if($scope.searchValue.inputvalue.length && (success.data.data[0].suggestion.length || success.data.data[1].suggestion.length || success.data.data[2].suggestion.length)) {
            $scope.searchValue.data = success.data.data;
            $('.sub-search').css('display','block');
            //console.log("aaya",$scope.searchValue);
        } else {
            $('.sub-search').css('display','none');
        }
        if (success.data.default_type == 'vendor') {
          success.data.default_type = 'vendors';
        } else if (success.data.default_type == 'image') {
          success.data.default_type = 'photos';
        }
        $('.searchBox').keyup(function(e) {
            if(e.keyCode == 13) {
               window.location.href =  config.domain + '/search/'+success.data.default_type + '/' + $scope.searchValue.inputvalue;
            }
        });
        $('.search-icon-button').on('click',function(e) {
          window.location.href =  config.domain + '/search/'+success.data.default_type+'/'+ $scope.searchValue.inputvalue;
        });
      },
      function(err){
        //$scope.searchValue.data = ""
        $('.searchBox').keyup(function(e) {
            if(e.keyCode == 13) {
               window.location.href =  config.domain + '/search/'+ 'vendors/'+ $scope.searchValue.inputvalue;
            }
        });
        $('.search-icon-button').on('click',function(e) {
          window.location.href =  config.domain + '/search/'+ 'vendors/'+ $scope.searchValue.inputvalue;
        });
        $('.sub-search').css('display','none');
        console.log("something went wrong");
      });
    }

    $('.bodycontainer').click(function() {
        $('.search-input-mobile').css('display','none');
    });

		$scope.sendSMS = function(){
			$(".err-msg").css("display", "none");
			if($scope.mobNum && $scope.mobNum.toString().length == 10){
				$.ajax({
					method: 'post',
					url: 'https://www.wedmegood.com/download_link_sms',
					data: {
						'mobile_number': $scope.mobNum
					},
					success: function(data) {
						delete $scope.mobNum;
						$(".full-sms-form").css("display", "none");
						$(".success-msg").css("display", "block");
						$timeout(function(){
							$("#downloadModal").modal("hide");
							$(".full-sms-form").css("display", "block");
							$(".success-msg").css("display", "none");
						}, 5000);
					},
					error: function(err){
						$(".err-msg").css("display", "block");
					}
				});
			}
		}

		$scope.DownloadGA = function(event,category,label){
			ga('send', 'event',{
				'eventCategory': event,
				'eventAction': category,
				'eventLabel': label
			});
		}

    // setTimeout(function () {
    //   preWeddingShootStatus(getPreweddingShootModalFlag());
    // }, 5000);

    function preWeddingShootStatus(flag){
      if(flag){
        angular.element('#signup-popup')[0].style.display = 'none';
        return;
      }
      angular.element('#signup-popup')[0].style.display = 'none';
    }


    function getPreweddingShootModalFlag(){
      if(location.pathname=='/terms'){
        return false;
      }

      if(localStorage.logged_in || localStorage.vendor_logged_in){
        return false;
      }

      if(!localStorage.preWedding){
        localStorage.preWedding = new Date().getTime();
        return true;
      }

      if(localStorage.preWedding < new Date().getTime()){
        return true;
      }

      return false;
    }

    $scope.searchSections = [
        {
            slug: 'all',
            type: 1,
            name: 'All',
            placeholder: 'Search: Vendors, Photos, Articles',
        },
        {
            slug: 'vendor',
            type: 2,
            name: 'Vendors',
            placeholder: 'Search: Wedding Vendors',
        },
        {
            slug: 'image',
            type: 3,
            name: 'Photos',
            placeholder: 'Search: Wedding Photos',
        },
        {
            slug: 'article',
            type: 4,
            name: 'Articles',
            placeholder: 'Search: Wedding Articles',
        },
    ];
    $scope.searchType = {
        slug: 'all',
        type: 1,
        name: 'All',
        placeholder: 'Search: Vendors, Photos, Articles',
    };
    $scope.searchTypeSelection = 1;

    $scope.changeSearchType = function(searchType) {
        $scope.searchType = searchType;
        $scope.searchTypeSelection = searchType.type;
        callPopularSearches(searchType.type);
        $scope.searchData = [];
        $scope.globalSearchQuery = '';
        document.getElementById('focusMe').focus();
    };

    $scope.typeTable = {
        all: 'all',
        image: 'photos',
        vendor: 'vendors',
        article: 'article',
        1: 'all',
        2: 'vendors',
        3: 'photos',
        4: 'article',
    };

    $scope.categoryTable = {
        1: 'wedding-photographers',
        2: 'wedding-jewellery',
        3: 'bridal-makeup',
        4: 'bridal-wear',
        5: 'groom-wear',
        6: 'wedding-decorators',
        7: 'wedding-catering',
        8: 'wedding-cards',
        9: 'wedding-cakes',
        10: 'wedding-venues',
        12: 'wedding-videography',
        13: 'mehendi-artists',
        14: 'trousseau-packers',
        15: 'sangeet-choreographers',
        16: 'wedding-favors',
        17: 'planners',
        18: 'wedding-accessories',
        19: 'djs',
        20: 'family-makeup',
        22: 'honeymoon-packages',
    };

    $scope.searchRedirect = function(query, searchType, obj) {
        console.log(query, searchType, obj);
        query = query.replace(/\/+/g, '-');
        if (obj && obj.link_url) {
            window.location.href = config.domain + '/' +  obj.link_url;
        } else {
            window.location.href = !searchType || searchType === "all" || searchType === 1 ? config.domain + "/search/photos/" + encodeURIComponent(query) : config.domain + "/search/" + $scope.typeTable[searchType] + "/" + encodeURIComponent(query);
        }
    }

    $scope.goTC = function(){
      window.open('https://www.wedmegood.com/blog/free-pre-wedding-shoot-terms-conditions/');
    }

    $scope.preWeddingModalClose = function(){
        // $scope.DownloadGA('Prewedding-popup', 'cancel', 'cross_icon');
        preWeddingShootStatus(false);
        localStorage.preWedding = new Date().getTime() + 20 * 24 * 60 * 60 * 1000;
    }

    $scope.openLogin = function(){
        // $scope.DownloadGA('Prewedding-popup', 'login', 'sign_in');
        $scope.preWeddingModalClose();
        openLoginModal();
    }

    $scope.openGlobalModal = function () {
        $scope.preWeddingModalClose();
        openGlobalSearchModal();
        callPopularSearches($scope.searchType.type);
    }

    $scope.openSignup = function(){
        // $scope.DownloadGA('Prewedding-popup', 'sign_up', 'create_account');
        $scope.preWeddingModalClose();
        showForm('#register_panel');
    }

    $scope.facebookLogin = function(){
        // $scope.DownloadGA('Prewedding-popup', 'facebook_login', 'continue_with_facebook');
        $scope.preWeddingModalClose();
        fblogin();
    }

}]);
if (window.location.href.indexOf('diwali') != -1 || window.location.href.indexOf('createwedding') != -1 || window.location.href.indexOf('uberweddings') != -1 || window.location.href.indexOf('project') != -1 ) {
    angular.bootstrap(document.getElementById("navApp"), ['navApp']);
}
